export default "__VITE_ASSET__X6AFA2v7__"